module.exports = __webpack_public_path__ + "static/media/download-img1.41ed9cb2.svg";